const CART_PRODUCT_INCREMENT_SECTION = 'cart-product-increment';

function parseQtyIncrement(value) {
  const n = parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

function getQtyIncrementFromInput(input) {
  if (!input) return 1;
  return parseQtyIncrement(input.dataset.qtyIncrement || input.min || 1);
}

function normalizeQtyToIncrement(quantity, increment) {
  const qty = parseInt(quantity, 10);
  if (!Number.isFinite(qty) || qty <= 0) return increment;
  if (qty <= increment) return increment;
  return Math.ceil(qty / increment) * increment;
}

function fetchProductIncrement(handle) {
  if (!handle) return Promise.resolve(1);

  return fetch(`/products/${encodeURIComponent(handle)}?section_id=${CART_PRODUCT_INCREMENT_SECTION}`)
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector('[data-cart-product-increment]');
      return parseQtyIncrement(el && el.getAttribute('data-cart-product-increment'));
    })
    .catch(() => 1);
}

function fetchProductIncrements(products) {
  const handles = [...new Set(products.map((p) => p.handle).filter(Boolean))];

  return Promise.all(
    handles.map((handle) =>
      fetchProductIncrement(handle).then((increment) => [handle, increment]),
    ),
  ).then((entries) => {
    const map = Object.fromEntries(entries);
    return products.map((product) => map[product.handle] || 1);
  });
}

function bindRelatedProductQtyControls(container) {
  container.querySelectorAll('.cart-related-product-qty-minus').forEach((btn) => {
    btn.onclick = function () {
      const row = this.closest('.cart-related-product-row');
      const input = row && row.querySelector('.cart-related-product-qty-input');
      if (!input) return;

      const increment = getQtyIncrementFromInput(input);
      const current = parseInt(input.value, 10) || increment;
      input.value = Math.max(increment, current - increment);
    };
  });

  container.querySelectorAll('.cart-related-product-qty-plus').forEach((btn) => {
    btn.onclick = function () {
      const row = this.closest('.cart-related-product-row');
      const input = row && row.querySelector('.cart-related-product-qty-input');
      if (!input) return;

      const increment = getQtyIncrementFromInput(input);
      const current = parseInt(input.value, 10) || increment;
      input.value = current + increment;
    };
  });

  container.querySelectorAll('.cart-related-product-qty-input').forEach((input) => {
    input.addEventListener('change', function (event) {
      event.stopPropagation();
      const increment = getQtyIncrementFromInput(this);
      this.value = normalizeQtyToIncrement(this.value, increment);
    });
  });
}

function renderRelatedProducts() {
  const container = document.getElementById('CartDrawerRelatedProductsSlider');
  if (!container) return;

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      if (!cart.items || !cart.items.length) return;

      const firstProductId = cart.items[0].product_id;

      const parsedLimit = parseInt(container.dataset.limit, 10);
      const limit = Number.isFinite(parsedLimit)
        ? Math.min(Math.max(parsedLimit, 1), 10)
        : 8;

      return fetch(
        `/recommendations/products.json?product_id=${firstProductId}&limit=${limit}&intent=related`,
      )
        .then((res) => res.json())
        .then((data) => {
          if (!data.products || !data.products.length) return;

          return fetchProductIncrements(data.products).then((increments) => {
            let html = '';

            data.products.forEach((product, index) => {
              const firstVariant = product.variants[0];
              const qtyIncrement = increments[index] || 1;

              const optionName =
                product.options && product.options[0]
                  ? typeof product.options[0] === 'string'
                    ? product.options[0]
                    : product.options[0].name
                  : 'Variant';

              const variantOptions =
                product.variants.length > 1
                  ? product.variants
                    .map((variant) => {
                      const label =
                        variant.option1 || variant.option2 || variant.option3 || variant.title;
                      return `<option value="${variant.id}">${label}</option>`;
                    })
                    .join('')
                  : '';

              html += `
              <div class="cart-related-product-row" data-index="${index}">
                <div class="cart-related-product-image">
                  <a href="${product.url}">
                    <img src="https:${product.featured_image}" alt="${product.title}" loading="lazy" decoding="async">
                  </a>
                </div>
                <div class="cart-related-product-info">
                  ${product.vendor
                ? `<div class="cart-related-product-vendor">${product.vendor}</div>`
                : ''
              }
                  <a href="${product.url}" class="cart-related-product-title">${product.title}</a>
                  ${firstVariant.sku
                ? `<div class="cart-related-product-sku">SKU: ${firstVariant.sku}</div>`
                : ''
              }
                  <div class="cart-related-product-price-wrap">
                    <span class="cart-related-product-price">
                      ${(firstVariant.price / 100).toLocaleString('en-CA', {
                style: 'currency',
                currency: 'CAD',
              })}
                    </span>
                    ${firstVariant.compare_at_price
                ? `<span class="cart-related-product-compare">
                            ${(firstVariant.compare_at_price / 100).toLocaleString('en-CA', {
                  style: 'currency',
                  currency: 'CAD',
                })}
                          </span>`
                : ''
              }
                  </div>
                </div>
                <div class="cart-related-product-actions">
                  <div class="cart-related-product-qty">
                    <button type="button" class="cart-related-product-qty-minus" aria-label="Decrease">−</button>
                    <input type="number" class="cart-related-product-qty-input" value="${qtyIncrement}" min="${qtyIncrement}" step="${qtyIncrement}" data-qty-increment="${qtyIncrement}" aria-label="Quantity">
                    <button type="button" class="cart-related-product-qty-plus" aria-label="Increase">+</button>
                  </div>
                  ${product.variants.length > 1
                ? `<button type="button" class="cart-related-product-add cart-related-product-add--options" data-variant-id="">
                          <span class="cart-related-product-add-text">OPTIONS</span>
                          <div class="loading-overlay__related hidden">
                            <div class="loading-overlay__spinner">
                              <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                              </svg>
                            </div>
                          </div>
                        </button>`
                : `<button type="button" class="cart-related-product-add" data-variant-id="${firstVariant.id}">
                          <span class="cart-related-product-add-text">ADD</span>
                          <div class="loading-overlay__related hidden">
                            <div class="loading-overlay__spinner">
                              <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                              </svg>
                            </div>
                          </div>
                        </button>`
              }
                </div>
                ${product.variants.length > 1
                ? `<div class="cart-related-product-variant-dropdown">
                        <div class="cart-related-product-variant-select-wrap">
                          <select class="cart-related-product-variant-select" data-product-index="${index}" aria-label="Select ${optionName}">
                            <option value="">Select ${optionName}</option>
                            ${variantOptions}
                          </select>
                        </div>
                      </div>`
                : ''
              }
              </div>
            `;
            });

            container.innerHTML = html;

            const params = new URLSearchParams(window.location.search);
            if (params.has('fxtest') && params.get('fxtest') === 'true') {
              const wrapper = document.querySelector('.cart-related-products');
              if (wrapper) wrapper.style.display = 'block';
            }

            bindRelatedProductQtyControls(container);

            // Variant select
            container.querySelectorAll('.cart-related-product-variant-select').forEach((select) => {
              select.onchange = function (event) {
                event.stopPropagation();
                const row = this.closest('.cart-related-product-row');
                if (!row) return;

                const button = row.querySelector('.cart-related-product-add');
                const dropdown = row.querySelector('.cart-related-product-variant-dropdown');
                if (!button) return;

                const variantId = this.value;
                const labelEl = button.querySelector('.cart-related-product-add-text');

                if (variantId) {
                  button.dataset.variantId = variantId;
                  if (labelEl) labelEl.textContent = 'ADD';
                  button.classList.remove('cart-related-product-add--options');
                  if (dropdown) dropdown.classList.add('is-open');
                } else {
                  button.dataset.variantId = '';
                  if (labelEl) labelEl.textContent = 'OPTIONS';
                  button.classList.add('cart-related-product-add--options');
                  if (dropdown) dropdown.classList.add('is-open');
                }
              };
            });

            // Add to cart (using section rendering API instead of full reload)
            container.querySelectorAll('.cart-related-product-add').forEach((btn) => {
              btn.onclick = function () {
                const variantId = this.dataset.variantId;

                if (!variantId) {
                  const row = this.closest('.cart-related-product-row');
                  const dropdown = row && row.querySelector('.cart-related-product-variant-dropdown');
                  if (dropdown) dropdown.classList.toggle('is-open');
                  return;
                }

                const row = this.closest('.cart-related-product-row');
                const input = row && row.querySelector('.cart-related-product-qty-input');
                const increment = getQtyIncrementFromInput(input);
                const quantity = input
                  ? normalizeQtyToIncrement(input.value, increment)
                  : increment;

                const buttonEl = this;
                const overlay =
                  row && row.querySelector('.loading-overlay__related');

                const setLoading = (isLoading) => {
                  if (buttonEl) {
                    if (isLoading) {
                      if (!buttonEl.dataset.originalLabel) {
                        buttonEl.dataset.originalLabel = buttonEl.innerHTML;
                      }
                      buttonEl.setAttribute('aria-disabled', 'true');
                      buttonEl.classList.add('loading');
                      const labelEl = buttonEl.querySelector('.cart-related-product-add-text');
                      if (labelEl) {
                        labelEl.textContent = '';
                      }
                    } else {
                      buttonEl.classList.remove('loading');
                      buttonEl.removeAttribute('aria-disabled');
                      if (buttonEl.dataset.originalLabel) {
                        buttonEl.innerHTML = buttonEl.dataset.originalLabel;
                      }
                    }
                  }

                  if (overlay) {
                    if (isLoading) {
                      overlay.classList.remove('hidden');
                    } else {
                      overlay.classList.add('hidden');
                    }
                  }
                };

                const cart =
                  document.querySelector('cart-drawer') ||
                  document.querySelector('cart-notification');

                if (!cart) {
                  setLoading(true);

                  const fallbackBody = JSON.stringify({
                    items: [{ id: variantId, quantity }],
                  });

                  fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                    },
                    body: fallbackBody,
                  })
                    .then((res) => res.json())
                    .then((data) => {
                      if (data.status && data.status >= 400) {
                        if (data.description) {
                          // eslint-disable-next-line no-alert
                          alert(data.description);
                        }
                        return;
                      }

                      if (window.routes && window.routes.cart_url) {
                        window.location = window.routes.cart_url;
                      } else {
                        window.location.reload();
                      }
                    })
                    .catch(() => { });

                  return;
                }

                setLoading(true);

                const config = fetchConfig('javascript');

                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];

                const formData = new FormData();
                formData.append('id', variantId);
                formData.append('quantity', quantity);

                if (typeof cart.getSectionsToRender === 'function') {
                  const sections = cart.getSectionsToRender().map((section) => section.id);
                  formData.append('sections', sections);
                  formData.append('sections_url', window.location.pathname);
                }

                if (typeof cart.setActiveElement === 'function') {
                  cart.setActiveElement(document.activeElement);
                }

                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                  .then((res) => res.json())
                  .then((data) => {
                    if (data.status) {
                      if (data.description) {
                        // eslint-disable-next-line no-alert
                        alert(data.description);
                      }
                      return;
                    }

                    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'cart-related-products',
                        productVariantId: variantId,
                      });
                    }

                    if (typeof cart.renderContents === 'function') {
                      cart.renderContents(data);
                    }
                  })
                  .catch(() => { })
                  .finally(() => {
                    setLoading(false);

                    if (typeof renderRelatedProducts === 'function') {
                      renderRelatedProducts();
                    }
                  });
              };
            });
          });
        });
    });
}

document.addEventListener('DOMContentLoaded', renderRelatedProducts);
